import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Modal, Button, Row, Col, Input, message } from 'antd';
const TextArea = Input.TextArea;
@inject('ecodeDemoStore')
@observer
class App extends React.Component {
  onSubmitNewTag = () => {
    const { ecodeDemoStore: { addNewTag, setMobxState, newTagValue, updateTag, updateTagId } } = this.props;
    if (!newTagValue) {
      message.error('标签名称不能为空！');
    } else {
      if (updateTagId) {
        updateTag();
      } else {
        addNewTag();
      }
      setMobxState({ visibleOfNewTag: false });
    }
  }
  onCancelNewTag = () => {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ visibleOfNewTag: false, newTagValue: '', newTagDes: '', updateTagId: '' });
  }
  handleInputChange = (v) => {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ newTagValue: v.target.value });
  }
  handleDesChange = (v) => {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ newTagDes: v.target.value });
  }
  render() {
    const { formPrefixCls, formItemLayout, ecodeDemoStore: { visibleOfNewTag, newTagValue, newTagDes} } = this.props;
    return (
      <Modal
        title={`自定义标签`}
        // className={`${prefixCls}-detailModal`}
        visible={visibleOfNewTag}
        onCancel={this.onCancelNewTag}
        width={950}
        zIndex={1000}
        footer={
          [(<Button onClick={this.onSubmitNewTag} type="primary" key="detailCancel">提交</Button>)]
        }
      >
        <Row className={`${formPrefixCls}-row`}>
          <Col xs={formItemLayout.labelCol.xs} sm={formItemLayout.labelCol.sm}>
            <span>自定义标签：</span>
          </Col>
          <Col xs={formItemLayout.wrapperCol.xs} sm={formItemLayout.wrapperCol.sm}>
            <Input
              type="text"
              value={newTagValue}
              onChange={this.handleInputChange}
            />
          </Col>
        </Row>
        <Row className={`${formPrefixCls}-row`}>
          <Col xs={formItemLayout.labelCol.xs} sm={formItemLayout.labelCol.sm}>
            <span>描述：</span>
          </Col>
          <Col xs={formItemLayout.wrapperCol.xs} sm={formItemLayout.wrapperCol.sm}>
            <TextArea rows={4} value={newTagDes}
              onChange={this.handleDesChange} />
          </Col>
        </Row>
      </Modal>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/sys/ecodeDemo/NewTag.js